var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',[_c('b-form-select',{attrs:{"value":_vm.value,"options":_vm.data,"size":"md","required":_vm.required,"select-size":_vm.select_size},on:{"input":function($event){return _vm.$emit('input', $event);}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }